import React, { useState } from 'react';
import { Card, Container, ListGroup, ListGroupItem } from 'react-bootstrap';

import Button from 'shared/components/Button/Button';
import { PaymentPlanData } from 'types/expiryRenewal';

import InfoModal from '../../common-components/InfoModal/InfoModal';
import RenewalPrice from '../atoms/RenewalPrice';

interface PaymentPlanProps {
  data?: PaymentPlanData;
}

const PaymentPlan = ({ data = {} }: PaymentPlanProps) => {
  const { items, isDirectDebit } = data;

  const [planModal, setPlanModal] = useState(false);

  return (
    <div className="px-1 pb-3">
      {/* Link */}
      <a
        className="text-decoration-underline"
        href="#paymentplan"
        onClick={(e) => {
          e.preventDefault();
          setPlanModal(true);
        }}
      >
        View Payment Plan
      </a>
      {/* Modal Container */}
      <InfoModal
        className="payment-info"
        show={planModal}
        heading={undefined}
        size={undefined}
        closeModal={undefined}
        footer={undefined}
        testId={undefined}
      >
        {/* Payment Plan */}
        <div className="text-start mb-3">
          <div className="pt-3">
            <h2>Payment Plan</h2>
            {isDirectDebit ? (
              <p>Your payment plan shows exactly what you’ll pay, with no hidden fees.</p>
            ) : (
              <p>Your payment plan shows exactly what you’ll pay and when you’ll pay it, with no hidden fees.</p>
            )}
            <Container className="overflow-auto" style={{ height: '300px' }}>
              <Card>
                <Card.Body className="m-1 p-0">
                  <ListGroup variant="flush">
                    {items && items?.map((item) => (
                      <ListGroupItem
                        key={item?.title}
                        className="d-flex justify-content-between align-items-start p-3"
                      >
                        <div className="me-auto">
                          <div className="fw-bold">
                            {item?.title}
                          </div>
                          {item?.dueDate && new Date(item?.dueDate).toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
                        </div>
                        <span className="mx-2">
                          <RenewalPrice size="inline" price={item.amount} />
                        </span>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </Card.Body>
              </Card>
            </Container>
          </div>
        </div>
        <Button
          onClickHandler={() => setPlanModal(false)}
          buttonText="Close"
          greyButton={undefined}
          darkGreyButton={undefined}
          outlineBlack={undefined}
          loading={undefined}
        />
      </InfoModal>
    </div>
  );
};

export default PaymentPlan;
